import {UsersService} from "../../services";
import {MiscService} from "../../services/misc/misc.service";


export const SERVICES =
{
    users: UsersService,
	misc: MiscService,
};
